import { render, staticRenderFns } from "./SuperAdminLogin.vue?vue&type=template&id=f2698024&scoped=true&"
import script from "./SuperAdminLogin.vue?vue&type=script&lang=js&"
export * from "./SuperAdminLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2698024",
  null
  
)

export default component.exports